import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { MatSnackBar } from "@angular/material";
import { environment } from '../../environments/environment';

import { ActividadService } from '../services/actividad.service';
import { Actividad } from '../models/actividad';
import { ActividadEditorComponent } from '../actividad-editor/actividad-editor.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
@Component({
  selector: 'app-actividad-list',
  templateUrl: './actividad-list.component.html',
  styleUrls: ['./actividad-list.component.css']
})
export class ActividadListComponent implements OnInit {


  models: Actividad[];
  Url = environment.imgUrl;

  constructor(private modelService: ActividadService, public dialog: MatDialog, private snackBar: MatSnackBar) {
    this.models = [];
  }

  ngOnInit() {
    this.getAll();
  }

  openEditor(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '600px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      id: id
    };

    const dialogRef = this.dialog.open(ActividadEditorComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        this.getAll();

      }
    );
  }

  delete(id) {

    const dialogConfig = new MatDialogConfig();

    dialogConfig.width = '300px';

    const dialogRef = this.dialog.open(ConfirmDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(
      data => {
        if (data == true) {
          this.modelService.delete(id).subscribe(
            val => {
              this.getAll();
              this.snackBar.open('Registro Eliminado', '', {
                duration: 2000,
              });
            });
        }
      }
    );

  }

  getAll() {

    this.modelService.getAll().subscribe(val => {
      this.models = val;

    },
      error => {
        console.log(error);
        console.log(<any>error);
      });

  }

}
